<template>
  <div class="p-my-5 search">
    <div class="">
      <div class="searchform p-fluid">
        <InputTags />
      </div>
      <SongList />
    </div>
    <router-link :to="{ name: 'List' }">
      <ListButton v-if="isExist" icon="list" />
    </router-link>
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";
import InputTags from "@/components/InputTags.vue";
import SongList from "@/components/SongList.vue";
import ListButton from "@/components/ListButton.vue";
import { useStore } from "vuex";

export default defineComponent({
  name: "Home",
  components: {
    InputTags,
    SongList,
    ListButton,
  },
  setup() {
    const store = useStore();
    return { store, queries: ref([]) };
  },
  computed: {
    isExist() {
      return this.store.state.list.cursor < this.store.state.list.ids.length;
    },
  },
});
</script>

<style scoped>
i {
  font-size: 18pt;
}
.searchform {
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
}
</style>
